import type { EntitlementValue } from "@enduring-systems/entitlements";

import { Textarea } from "@/common/ui/textarea";

export interface FallbackControlProps {
  readonly value: EntitlementValue;
}

export function FallbackControl({ value }: FallbackControlProps): JSX.Element {
  return (
    <div className="flex flex-col gap-2">
      <p className="text-sm text-muted-foreground">Unsupported entitlement type (read-only)</p>
      <Textarea
        data-testid="entitlement-control-fallback"
        className="min-h-16 font-mono text-sm"
        readOnly
        value={JSON.stringify(value, null, 2)}
      />
    </div>
  );
}
